import { useMemo } from 'react'

import { ProjectTranslator } from 'src/translators'
import { useGetProjectsQuery } from 'src/types/generated'

export const useGetProjects = () => {
  const { loading, data, error, refetch } = useGetProjectsQuery()

  return {
    loading,
    projects: useMemo(() => {
      return data && data.projects ? ProjectTranslator.toEntities(data.projects) : []
    }, [data]),
    error,
    refetch,
  }
}
